import { useNotifications } from '../../providers/NotificationsProvider';
import { useResponsive } from '../../providers/ResponsiveProvider';
import { HeaderIconButton } from '../Header/HeaderIconButton';
import NotificationsDrawer from './NotificationsDrawer';
import NotificationsPopup from './NotificationsPopup';
import { Badge } from '@presov.sk/presov-ui-react';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import React from 'react';

const Notifications: React.FC = () => {
  const { unreadCount } = useNotifications();
  const { isMd } = useResponsive();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement>();
  const [isOpenDrawer, setIsOpenDrawer] = React.useState(false);

  const isOpenPopup = Boolean(anchorEl);
  const id = isOpenPopup ? 'popover' : undefined;

  const openPopper = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseNotifications = () => {
    setAnchorEl(null);
    setIsOpenDrawer(false);
  };

  const handleOpenNotifications = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    if (isMd) {
      openPopper(event);
    } else {
      setIsOpenDrawer(true);
    }
  };

  return (
    <>
      <HeaderIconButton onClick={handleOpenNotifications}>
        <Badge
          badgeContent={unreadCount}
          max={9}
          slotProps={{
            badge: {
              sx: {
                p: 0,
                fontSize: 10,
                bgcolor: 'secondary.main',
                color: 'primary.light',
                fontWeight: 'bold',
                minWidth: 16,
                maxWidth: 16,
                minHeight: 16,
                maxHeight: 16,
                top: 2,
                right: 2,
                outline: (theme) => `1px solid ${theme.palette.primary.main}`,
              },
            },
          }}
        >
          <NotificationsIcon
            sx={{
              color: (theme) => theme.palette.primary.contrastText,
            }}
          />
        </Badge>
      </HeaderIconButton>

      <NotificationsDrawer
        isOpen={isOpenDrawer}
        onClose={handleCloseNotifications}
      />

      <NotificationsPopup
        id={id}
        isOpen={isOpenPopup}
        anchorEl={anchorEl}
        onClose={handleCloseNotifications}
      />
    </>
  );
};

export default Notifications;
